module.exports = __webpack_public_path__ + "static/media/agua-01.eb11e7ce.webp";